import React, { useState } from 'react'
import axios from 'axios'
import {
  Box,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Paper,
  Alert,
  AlertTitle,
  IconButton,
  Tooltip,
} from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

const AddBotToGroup = () => {
  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState(null)
  const [error, setError] = useState(null)

  const checkBotAddition = async () => {
    setLoading(true)
    setError(null)
    setResult(null)

    try {
      const response = await axios.post(
        'https://admin-protocarp.ru/php/bot/get_group_id.php'
      )

      if (response.data.success) {
        setResult({
          chatId: response.data.chat_id,
          chatTitle: response.data.chat_title,
        })
      } else {
        setError(response.data.error || 'Не удалось получить данные о группе')
      }
    } catch (err) {
      setError(err.message || 'Произошла ошибка при подключении к серверу')
    } finally {
      setLoading(false)
    }
  }

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
    // Можно добавить snackbar/уведомление об успешном копировании
  }

  return (
    <Box
      sx={{
        maxWidth: 600,
        mx: 'auto',
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
      }}
      component={Paper}
      elevation={3}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        Добавьте бота в группу Telegram
      </Typography>

      <Typography variant="body1" gutterBottom>
        Для получения ID группы выполните следующие действия:
      </Typography>

      <List dense>
        <ListItem>
          <ListItemText primary="1. Добавьте нашего бота @YourBotName в свою группу" />
        </ListItem>
        <ListItem>
          <ListItemText primary="2. Назначьте бота администратором (рекомендуется)" />
        </ListItem>
        <ListItem>
          <ListItemText primary="3. Нажмите кнопку ниже после добавления" />
        </ListItem>
      </List>

      <Button
        variant="contained"
        onClick={checkBotAddition}
        disabled={loading}
        size="large"
        sx={{ alignSelf: 'flex-start' }}
        startIcon={
          loading ? <CircularProgress size={20} color="inherit" /> : null
        }
      >
        {loading ? 'Проверяем...' : 'Проверить добавление бота'}
      </Button>

      {result && (
        <Alert
          severity="success"
          sx={{ mt: 2 }}
          action={
            <Tooltip title="Копировать ID">
              <IconButton
                color="inherit"
                size="small"
                onClick={() => copyToClipboard(result.chatId)}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          }
        >
          <AlertTitle>Группа успешно обнаружена!</AlertTitle>
          <Typography variant="body2">
            ID группы: <strong>{result.chatId}</strong>
          </Typography>
          <Typography variant="body2">
            Название: <strong>{result.chatTitle}</strong>
          </Typography>
        </Alert>
      )}

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          <AlertTitle>Ошибка</AlertTitle>
          {error}
        </Alert>
      )}
    </Box>
  )
}

export default AddBotToGroup
